module.exports = __webpack_public_path__ + "static/media/glacier.dd6b9317.png";